import classNames from "classnames";

import "./styles.scss";

const ITEMS = [
  { key: "antivirus", header: "Antivirus", value: "None" },
  { key: "autoupdate", header: "Auto Update", value: "None" },
  { key: "firewall", header: "Firewall", value: "None" },
  { key: "internet_settings", header: "Internet Settings", value: "None" },
  { key: "user_account_control", header: "UAC", value: "None" },
  {
    key: "windows_security_center_service",
    header: "Windows Security Center",
    value: "None",
  },
];

const SecurityRatings = ({ ratings }) => {
  const getRatingClass = (value) => {
    const lower = value?.toLowerCase();
    if (lower === "good" || lower === "poor") return lower;
    return "poor"; // fallback
  };

  return (
    <div className="security-ratings__display">
      {ITEMS.map((item, index) => (
        <div
          key={item.key}
          className={classNames(
            "security-ratings__border",
            `security-ratings__border__${getRatingClass(ratings[item.key])}`,
          )}>
          <span className="security-ratings__text">
            {item.header} : {ratings[item.key] || item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SecurityRatings;
